
/**
 * @export
 * @enum {string}
 */
export enum ReportType {
    USER_USAGE_REPORT = 'USER_USAGE_REPORT',
    EXCEL_REPORT = 'EXCEL_REPORT'
}